import React from "react";
import clsx from "clsx";

const Item = ({ label, value }) => (
  <div>
    <div className="text-gray-500">{label}</div>
    <div className="font-medium">{value}</div>
  </div>
);

function Th({ children }) {
  return <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-gray-600">{children}</th>;
}

function Td({ children, className = "" }) {
  return <td className={clsx("px-4 py-3 align-top", className)}>{children}</td>;
}

/* ============ Pump Events ============ */
const PumpEventsTable = () => {
  const rows = [
    {
      event: "Favourable Government Policy/tailwinds",
      rationale:
        "Policy tailwinds can expand market size, margins, or funding—driving re-ratings.",
      examples: [
        "AI: Netweb, E2E Networks rallied after India's foundation-model push",
        "Data Centers: Anant Raj, Black Box after DC policy cues",
        "Rare Earth Minerals: GMDC keep pumping due to Rare earth push by government",
        "Fertilisers: Moves after subsidy/price support",
        "Ethanol/Sugar: Blending mandates boost realizations",
        "Solar Stocks: Solar Stocks became stars due to government push, but now lagging due to oversupply",
        "EV Push in Public Transport: Olectra Greentech boom due to EV push",
        "Defense Stocks: Defense Stocks increased due to government focus on indigenous supply",
        "Automobile Stocks: Automobile stocks increased after GST reduction announcement",
        "EMS stocks : Dixon and kaynes moved significantly with favorable PLI schemes"
      ],
      caveat:
        "Policy timelines & execution risk; initial pops can fade if benefits are delayed.",
    },
    {
      event: "Stock Split Announcement",
      rationale:
        "Improves perceived affordability & liquidity; can attract retail flows.",
      examples: [
        "Godfrey Phillips saw strength into/around split timeline",
        "MRF rallied post its 2023 stock split announcement",
        "MCX rallied around 20-25% during 1:5 stock split in jan 2026"
      ],
      caveat:
        "No change in intrinsic value; euphoria can reverse if earnings don't follow.",
    },
    {
      event: "Correlation And Arbitrage",
      rationale:
        "Sometime correlated entities provide good opportunities",
      examples: [
        "After GST cut announcement on vehicles, vehicle finance stocks increased",
        "Once GM brewery increased by 30% in a week, other country liquor stock Associated alcohol followed",
        "Due to high gold prices, Gold finance stocks went up but jewelry stocks went down",
        "Due to low crude prices, Oil refinery and petro products company stocks went up",
        "When Raw Egg Price reached all time high, SKM egg product soured high",
        "Sugar price surges led to rallies in Balrampur Chini Mills following global commodity trends",
        "Rising steel prices boosted JSW Steel, with correlated gains in downstream firms like APL Apollo Tubes.",
        "Rising silver prices in 2025 boosted prices of HINDZINC",
        "Rising copper prices in 2025 boosted prices of HIND COPPER",
      ],
      caveat:
        "Hard to get data.",
    },
    {
      event: "Subsidiary IPO",
      rationale:
        "Unlocks value, improves transparency, and may bring cash to parent/holding co.",
      examples: [
        "Tata Investment jumped ~35% on Tata Capital IPO news",
        "ITC surged ahead of its ITC Hotels demerger and potential IPO",
        "Larsen & Toubro rose on L&T Infotech's listing buzz"
      ],
      caveat:
        "IPO pricing/allocations & post-listing performance matter; one-offs.",
    },
    {
      event: "Industry re-rating due to IPO / acquisition",
      rationale:
        "When a new IPO comes at higher valuation, or acquisition happen at higher valuation. It can rerate other Companies from same industry",
      examples: [
        "Due to Groww IPO listing at higher valuation, shares of Angle one increased",
        "Due to news about sale of Bangalore royal challenger team, stocks of Suntv increased as they own Hyderabad Sunrisers",
        "Zomato's high-valuation acquisition of Blinkit led to re-ratings in peers like Swiggy pre-IPO"
      ],
      caveat:
        "Many times this re-ratings are temporary and stock can return to their original price",
    },
    {
      event: "Large Strategic Stake by FII/DII/Well Established Investor",
      rationale:
        "Signals strong institutional conviction & funding runway for turnarounds.",
      examples: [
        "After IHC's ~43.5% stack buy in Samaan Capital saw ~25% up-move",
        "Both Cartrade and Nazara tech went up after Nikhil Kamath Investment",
        "E2E network stock increased nicely over a year after L&T bought stack",
        "Yes bank went around 15% up after Sumitomo Mitsui acquisition of a 20% stack",
        "Suzlon Energy rallied after stake purchases by marquee investors like BlackRock"
      ],
      caveat:
        "If due diligence concerns emerge later, momentum can unwind quickly.",
    },
    {
      event: "Successful Liquidity infusion - FPO / Rights / QIP ",
      rationale:
        "Deleveraging or growth capital without new debt reduces risk; boosts confidence.",
      examples: [
        "Vodafone Idea rallied post a successful FPO",
        "PNB Housing Finance gained post QIP in 2024"
      ],
      caveat:
        "Dilution math matters; if use-of-proceeds underwhelms, gains may fade.",
    },
    {
      event: "Mergers",
      rationale:
        "Synergies, scale, and cross-sell potential can re-rate the combined entity.",
      examples: [
        "Zee moved on Zee-Sony merger buzz (later failed; stock fell back)",
      ],
      caveat:
        "Deal closure risk (regulatory/terms). Rumors can cause whipsaws. \
        Gain can diminish as soon as merge completes most gains come before merger.",
    },
    {
      event: "Demergers / Value Unlock",
      rationale:
        "Separates high-growth or asset-heavy units; clearer narratives attract capital.",
      examples: [
        "Raymond demerger value unlock; BEML & BEML Land Assets split",
        "Canara Bank price increase during Canara Robeco & Canara HSBC Life IPO listing",
        "Vedanta's demerger of multiple units led to parent stock gains"
      ],
      caveat:
        "Listing ratios & final structures matter; sometimes value takes time to surface.",
    },
    {
      event: "Strategic Partnerships",
      rationale:
        "A strong strategic partnership with a large player can significantly enhance a company's long-term growth prospects.",
      examples: [
        "Force Motors' partnership with BMW helped the company immensely.",
        "Bharat Forge's partnership with Rheinmetall helped it enter the global defence and artillery manufacturing space.",
        "Dixon Technologies' partnerships with Samsung and Motorola boosted its scale and credibility in electronics manufacturing.",
        "Uno Minda gained from multiple Joint ventures and increased their product portfolio."
      ],
      caveat:
        "Caution is required, as partnerships may fail to deliver expected benefits if they do not work out as planned.",
    },
    {
      event: "New Product Launch/new verticals/innovation",
      rationale:
        "Sometimes launch of new hero products can give long term profitability.",
      examples: [
        "Tata Motors pumped on EV model launches like Nexon EV",
        "Eicher Motors pumped after launching premium bikes",
        "Solar industries traditionally an explosive company, gained after venturing into new products like grenades and pinaka rockets",
        "KPIT performed very when due to innovation in automotive software"
      ],
      caveat:
        "Need to continuously monitor how well new product is performing",
    },
    {
      event: "Large Volume Spike at lower level",
      rationale:
        "Sudden 5-10x volume can flag accumulation or new information in the market.",
      examples: [
        "10x delivery-backed spikes often precede trends",
        "Adani Power saw a reversal after a volume spike in 2023",
        "ESAB India Stock price moved up after huge volume breakout - volume was not from bulk deal",
        "Anup Engineering price reversed after spike - but volume was mainly bulk deal"
      ],
      caveat:
        "HFT/prop churn can fake signals; always check delivery % and source of volume if it is coming from bulk deal.",
    },
    {
      event: "News Events",
      rationale:
        "Many News events may pump or dump stock prices temporarily",
      examples: [
        "During Indo-Pak War all defense stock pumped",
        "Due to rumours that SEBI will cancel all weekly expiry options all brokerage stocks went down",
        "Due to News about stricter regulation on gold loans all gold loan stocks went down",
        "Due to government ban on real money gaming both Nazara and Deltacorp went down",
        "SunTV stock price went up when DMK won Karnataka election",
        "Heritage Foods price went up after specular performance by TDP in Loksabha election",
        "COVID-19 vaccine news pumped pharma stocks like Dr. Reddy's",
        "Budget announcements on infrastructure boosted Larsen & Toubro"
      ],
      caveat:
        "Trading News is double edge sword, sometimes it can go against",
    },
    {
      event: "Global Parallels",
      rationale:
        "Moves in global peers or platforms spill over to local analogs.",
      examples: [
        "DeepSeek shock hit Indian IT sector; Oracle's surge lifted OFSS read-across",
        "Hyundai Korea pumped due to listing of Hyundai India",
        "When all semiconductor companies in USA were pumping, Moschip in india started raising as well as there are not many semiconductor options",
        "Many so called Indian AI stocks like Netweb and E2E network pumped as global AI stocks were pumping",
        "Tesla's EV surge influenced Indian peers like Tata Motors"
      ],
      caveat:
        "Correlations change; ensure business models are truly comparable.",
    },
    {
      event: "Behavioural Changes",
      rationale:
        "Changes in consumer behaviour can create entirely new markets or significantly expand existing ones.",
      examples: [
        "As Indians started buying more electronics on EMI, it significantly boosted the growth of many NBFCs and fintech lenders.",
        "Consumers increasingly preferred large organized retail stores over local kirana shops, which helped the rapid expansion of DMart.",
        "The rise of food delivery habits led to the explosive growth of platforms like Zomato and Swiggy.",
        "The shift toward digital payments after UPI adoption transformed companies like Paytm, PhonePe, and Google Pay into mass-market platforms.",
        "Work-from-home culture increased long-term demand for laptops, broadband services, and home office infrastructure.",
        "Rising health awareness boosted demand for wellness, diagnostics, and fitness-related businesses.",
        "Shift to online education post-COVID boosted Byju's (pre-crisis) and Unacademy"
      ],
      caveat:
        "Behavioural trends can reverse quickly due to regulation, economic cycles, or changing preferences, so long-term sustainability must always be evaluated."
    },
    {
      event: "Premiumisation",
      rationale:
        "Companies that successfully ride the premiumisation trend tend to enjoy higher margins, stronger brand loyalty, and superior long-term growth.",
      examples: [
        "Titan successfully led the premiumisation of the Indian jewellery market through brands like Tanishq, Mia, and Zoya.",
        "Apple built a loyal premium customer base in India despite higher pricing, driving strong profitability.",
        "Asian Paints expanded into premium home décor and luxury coatings with higher-margin product lines.",
        "Royal Enfield transformed from a mass commuter brand into a premium lifestyle motorcycle brand.",
        "Nestlé pushed premium food and nutrition products to improve margins in urban markets.",
        "Marico's premium personal care brands helped lift overall EBITDA margins."
      ],
      caveat:
        "Premiumisation works best in expanding or resilient income segments; during economic slowdowns, consumers may temporarily trade down to more affordable alternatives."
    },
    {
      event: "Quality at Lows / Mean Reversion / Extreme fall in short time",
      rationale:
        "Solid businesses at depressed valuations can bounce on small positive triggers.",
      examples: [
        "Laxmi Dental spiked ~20% from ~₹300 levels on interest revival",
        "Sona BLW reversed from 400 levels",
        "HDFC Bank rebounded from pandemic lows on rate cut signals",
        "KSR Footware After huge fall after listing rebounded 50% in just 3 days",
        "Idea recovered to 12 Rs after fall to 6 Rs",
        "Ola Electric recovered from 32 Rs"
      ],
      caveat:
        "“Cheap” can stay cheap for long; confirm fundamentals/improving data points. Sometimes catching falling knife can backfire \
        for example Yes Bank, Suzlon, Reliance Power Sank Investors capital badly",
    },
    {
      event: "Cyclical Turns",
      rationale:
        "Capital-intensive/commodity/credit cycles create multi-quarter trends.",
      examples: [
        "Even top names swing with cycles (cement, metals, lenders)",
        "Real Estate: DLF gained during housing demand upturns cycle"
      ],
      caveat:
        "Timing is hard; misreading cycle length causes drawdowns.",
    },
    {
      event: "Index Inclusion / Weight Increase",
      rationale: "Inclusion (Nifty/MSCI/FTSE) brings forced passive inflows.",
      examples: [
        "Jio Financial Services surged on Nifty inclusion",
        "Trent seen marginal hike post sensex(FTSE) weight hike."
      ],
      caveat: "Event-day selling as active funds book gains, if stock is facing major headwinds then it might not give Benefits"
    },
    {
      event: "Earnings Beat / Guidance Upgrade",
      rationale: "Better-than-expected results or higher guidance lift confidence.",
      examples: [
        "Strong quarterly beats re-rate midcaps quickly"
      ],
      caveat: "One-offs (asset sale, tax credit) can mislead."
    },
    {
      event: "Buybacks / Special Dividends",
      rationale: "Signal promoter confidence; improves EPS and ratios.",
      examples: [
        "Buyback price often anchors near-term stock"
      ],
      caveat: "Debt-funded or small buybacks are weak signals."
    },
    {
      event: "Capacity Addition / Capex Commissioning",
      rationale: "New plants and capacity ramping boost volumes and margins.",
      examples: [
        "Cement/steel/utilities stocks rerate on commissioning",
        "Antony Waste moved high after showing 250 Cr Capex in March 2023",
        "When Public lending Companies like PFC, RFC, IREDA do huge lending, Power sector increases",
        "HVDC stocks went up due to huge capex in Power Transmission sector",
        "UltraTech Cement rallied post new plant commissions"
      ],
      caveat: "Delays or demand mismatch hurt ROI."
    },
    {
      event: "Debt Refinance / Rating Upgrade / break even hit",
      rationale: "Lower borrowing costs and improved perception support valuations.",
      examples: [
        "Rating upgrades spark re-ratings in NBFCs",
        "Adani Ports gained on debt refinancing deals.",
        "Zomato rallied after reporting first ever profitability"
      ],
      caveat: "Macro shocks can override credit signals."
    },
    {
      event: "Promoter Stake Actions",
      rationale: "Stake increases or pledge reduction build investor confidence.",
      examples: [
        "Promoter buying after sell-off often sparks rebounds"
      ],
      caveat: "Token buys/pledge re-creation can backfire."
    },
    {
      event: "Sectoral Approvals / Clearances",
      rationale: "Approvals (mining, PLI, spectrum, ethanol) create catalysts.",
      examples: [
        "Pharma rallies on USFDA clearance",
        "Bharti Airtel gained on spectrum auction wins.",
        "Coal India surged post mining approval expansions"
      ],
      caveat: "Regulatory risks and timelines can slip."
    },
    {
      event: "Global activities on commodities and currencies and policies",
      rationale: "Falling input costs, INR stability, policy shifts benefit sectors.",
      examples: [
        "Crude falls boost FMCG; steel rallies on price hikes",
        "Rate-sensitive banks/NBFCs rally on cut expectations",
        "Lift on export ban on certain products from India can improve exports",
        "Gold price spikes lifted Muthoot Finance."
      ],
      caveat: "Regulatory risks and timelines can slip."
    },
    {
      event: "New Management Appointment / Turnaround Leadership",
      rationale:
        "Appointment of a credible new CEO, MD, or key executive (especially from reputed firms or with proven track records) signals potential operational overhaul, improved governance, or strategic revival, attracting fresh investor interest and triggering re-ratings.",
      examples: [
        "Yes Bank rallied sharply after Prashant Kumar was appointed CEO in 2020, signaling a new chapter post-crisis.",
        "IDFC First Bank surged after V. Vaidyanathan (ex-HDFC Bank) took over as MD & CEO in 2018.",
        "Vodafone Idea pumped after appointing Akshaya Moondra as MD & CEO in 2022, bringing telecom turnaround experience.",
        "Suzlon Energy rallied strongly after Tulsi Tanti's son, Tanti family, and new professional management took charge post-restructuring.",
        "Reliance Power gained momentum after appointing Anil Sardana as MD & CEO in 2023, bringing his Tata Power experience.",
        "Jindal Steel & Power rose after Naveen Jindal stepped back and professional management under Bimlendra Jha took over.",
        "GMR Airports pumped after appointing Ludovic Arnault (ex-Airport operator) as CEO, signaling global expertise.",
        "PC Jewellers saw a sharp rebound after appointing a new professional CEO and board restructuring in 2024."
      ],
      caveat:
        "Not all appointments deliver results — success depends on actual execution, board support, and underlying business health. Some new leaders face internal resistance or legacy issues, leading to limited or temporary impact."
    },
    {
      event: "Some general points",
      rationale:
        "Some general points",
      examples: [
        "Moat/Market leader Companies are always gold - CDSL, MCX, Asian Paint, Airtel, HDFC Bank",
        "Low capital need, High Margins - software companies, cartrade, nazara",
      ],
      caveat:
        "",
    },
  ];

  return (
    <section className="w-full">
      <h2 className="text-xl md:text-2xl font-semibold mb-3">Events That Can Pump Stock Prices</h2>

      {/* Mobile: Cards */}
      <div className="grid grid-cols-1 gap-3 md:hidden">
        {rows.map((r, i) => (
          <div key={i} className="rounded-xl border border-gray-200 p-4 bg-white">
            <div className="text-base font-semibold">{r.event}</div>
            <p className="mt-1 text-sm text-gray-700">
              <span className="font-medium">Why:</span> {r.rationale}
            </p>
            <div className="mt-2">
              <div className="text-sm font-medium text-gray-600">Examples</div>
              <ul className="mt-1 list-disc pl-5 text-sm text-gray-700 space-y-0.5">
                {r.examples.map((e, idx) => (
                  <li key={idx}>{e}</li>
                ))}
              </ul>
            </div>
            <p className="mt-2 text-sm text-amber-700">
              <span className="font-medium">Caveat:</span> {r.caveat}
            </p>
          </div>
        ))}
      </div>

      {/* Desktop: Table */}
      <div className="hidden md:block overflow-x-auto rounded-xl border border-gray-200 bg-white">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-50 text-gray-700">
            <tr>
              <Th>Event</Th>
              <Th>Why it can move prices</Th>
              <Th>Examples</Th>
              <Th>Caveats / Risks</Th>
            </tr>
          </thead>
        <tbody className="divide-y divide-gray-100">
            {rows.map((r, i) => (
              <tr key={i} className={i % 2 === 0 ? "bg-white" : "bg-gray-50/60"}>
                <Td className="font-semibold">{r.event}</Td>
                <Td>{r.rationale}</Td>
                <Td>
                  <ul className="list-disc pl-5 space-y-0.5">
                    {r.examples.map((e, idx) => <li key={idx}>{e}</li>)}
                  </ul>
                </Td>
                <Td className="text-amber-700">{r.caveat}</Td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

/* ============ Dump Events ============ */
const DumpEventsTable = () => {
  const rows = [
    {
      event: "Change in Government Policy",
      rationale:
        "Sometimes hostile government policy can destroy entire stock, taboo stocks are always under government scrutiny",
      examples: [
        "Real Money Gaming Apps: Gaming app like Nazara and Deltacorp had sharp fall after government curbs",
        "Tobacco stocks: tobacco stocks faces always faces constant tax hike, which impacts the revenue of companies",
        "Alcohol Stocks: alcohol stocks faces constant threats of government regulation even ban in some states, keep watching if any compny is dominant in a particular state and if election is coming up",
        "Stock Brokers: Lot of stock brokerage stock went down duty hike in LTCG and STCG, and SEBI's sticker rules on option trading",
        "Removal of anti dumping duties: Domestic Solar stocks ofter face issue when government removes anti dumping duty on China supply",
        "Gold Finance Stocks: Due to RBI's strict regulation on gold loan approvals gold stocks went down",
        "IEX : IEX stock crashed 30% due to government announcement of market decoupling",
        "EV Subsidy Cuts: Olectra Greentech and JBM Auto corrected sharply after FAME-III subsidy reduction talks."
      ],
      caveat:
        "Policy changes can sometimes be temporary or diluted; stocks may recover if the final policy is less severe than feared.",
    },
    {
      event: "News, Events or rumours",
      rationale:
        "Any announcement like US election, tariffs, war can impact Indian stocks",
      examples: [
        "Trump's tariffs impacted Indian Rice, Shrimp, Textile and Pharma stocks",
        "IEX stock crashed 20% due to world bank debarment news due to corruption",
        "Indigo Stock prices crashed 18% in a week due to mass scale flight cancellations.",
        "Many stock prices went down during May 2025 Indo Pak conflict",
        "Kalyan Jewellers shares fall 8% amid Motilal Oswal bribery rumours",
        "COVID-19 lockdowns: Aviation, hospitality, and retail stocks (InterGlobe, Lemon Tree, DMart) crashed.",
        "Budget 2024: PSU banks and defence stocks corrected after no major capital infusion announcements.",
      ],
      caveat:
        "Trading News is double edge sword, sometimes it can go against",
    },
    {
      event: "Large Stack Sale by FII/DII/Promoter",
      rationale:
        "Signals that there might be something wrong with company, also inject lot of free float in market",
      examples: [
        "Himadry chemical stock went down due to stake sale by Bain capital in 2021",
        "Indigo went down after promoter stack sale",
        "Paytm went down after Warren Buffett's Berkshire Hathaway exit from stock",
        "Ola seen huge price fall after promoter bhavish aggarwal sold stack"
      ],
      caveat:
        "It can be just temporary down trade, stock might be fundamentally strong",
    },
    {
      event: "Sale by early investors during IPO",
      rationale:
        "There are lot of early investors who wants exit through IPO, so newly listed companies can go down for brief period of time",
      examples: [
        "Zomato, Paytm went down huge after IPO before recovering",
        "Laxmi Dental Went down after IPO despite being decent company",
        "Paytm never seen same IPO price again",
        "Nykaa fell heavily post-IPO due to anchor and PE exits.",
        "FirstCry and Mamaearth (Honasa) corrected after early investor sales.",
        "Cartrade took a long time to recover after post-IPO price decline"
      ],
      caveat:
        "It can be just temporary down trade, stock might be fundamentally strong",
    },
    {
      event: "Unsuccessful Large FPO / Rights / OFS",
      rationale:
        "Any unsuccessful FPO can be huge blow to credibility of company and can impact heavily",
      examples: [
        "Due to failed FPO of Adani stock due to hindenburg issue, stock went free fall",
        "Due to failed IPO of Wework USA, it's full valuation got destroyed",
        "Suzlon Energy corrected after earlier failed fundraising attempts.",
        "Yes Bank fell sharply on repeated unsuccessful capital raise attempts."
      ],
      caveat:
        "Dilution math matters; if use-of-proceeds underwhelms, gains may fade.",
    },
    {
      event: "Unsuccessful Mergers and acquisitions",
      rationale:
        "Failure to do mergers can negatively impact stock price",
      examples: [
        "Failure of Zee-Sony merger",
        "Failure of Future retail acquisition by Reliance destroyed future retail",
        "Thomas Cook India dropped after failed acquisition talks.",
        "IDFC First Bank corrected after IDFC merger deal delays.",
      ],
      caveat:
        "Deal closure risk (regulatory/terms). Rumors can cause whipsaws.",
    },
    {
      event: "Large Volume Spike on High Levels",
      rationale:
        "Sudden 5-10x volume spike at stock high might suggest selling.",
      examples: [
        "10x delivery-backed spikes often precede trends",
        "Adani Power saw heavy selling volume at 2024 highs before correction.",
        "IRCTC dropped after huge volume spikes near record highs.",
      ],
      caveat:
        "HFT/prop churn can fake signals; always check delivery % and source of flow.",
    },
    {
      event: "whistleblowers and Short Sellers",
      rationale:
        "Many stock that might hide some internal issues can go down if whistleblowers or short Sellers report come out",
      examples: [
        "UPL stock went down after whistleblowers report",
        "Adani Stock down after Hindenburg report",
        "Kaynes Tech stock crashed 40% in a month due to news of irregularity reporting by Kotak",
        "Angel One fell after allegations of mis-selling surfaced."
      ],
      caveat:
        "Many times whistleblowers might be biased or some kind of vendetta. verify this carefully even Hindenburg who have precise track record had motivated report on adani",
    },
    {
      event: "Corporate Governance Issue",
      rationale:
        "Market takes corporate governance issues very seriously, it is better to be very careful with this companies",
      examples: [
        "Easemytrip stock seen large fall due to no clear direction by management and frequent changes",
        "PC Jewellers remains beaten down due to corporate governance issues",
        "Rajesh Export went down due to corporate governance issues",
        "Yes Bank crashed after Rana Kapoor-era governance issues.",
      ],
      caveat:
        "Some governance issues are fixable with new management or restructuring; others can be terminal.But always take this seriously even the first ever report",
    },
    {
      event: "Pledging Shares or high interest loans",
      rationale:
        "If company has to pledge the share to raise capital that proves company is not able to get capital from other mediums",
      examples: [
        "In 2019, Zee Entertainment's stock plummeted after news surfaced that its promoters had pledged a significant portion of their shares to lenders",
        "Under Anil Ambani, the Reliance ADA Group lost control of multiple companies, largely due to a combination of heavy debt and excessive share pledging.",
        "Suzlon Energy corrected sharply during high pledging phases.",
        "GMR Infrastructure fell repeatedly on pledging and debt issues.",
        "Jaiprakash Power Ventures remained under pressure due to high pledging."
      ],
      caveat:
        "If pledging go beyond control, turnaround if mostly impossible. But in some cases restructuring can happen example cafe coffee day or suzlon, but this can take very long time",
    },
    {
      event: "Cyclical Down or Oversupply Cycles",
      rationale:
        "Capital-intensive/commodity/credit cycles create multi-quarter trends.",
      examples: [
        "Even top names swing with cycles (cement, metals, lenders)",
        "Solar Sector stocks started slowing down due to oversupply",
        "After aggressive lending in solar sector Companies like IREDA had to cut down",
        "Steel stocks (JSW Steel, Tata Steel) corrected during china oversupply.",
        "NBFCs (Bajaj Finance, Muthoot) corrected during credit cycle tightening."
      ],
      caveat:
        "Cycles eventually turn; early identification of bottoming signals can offer entry points. Incorrect reading can cause trap",
    },
    {
      event: "FnO Ban list",
      rationale:
        "When Stock enters into FnO ban list trade volume dries up this can push stock down.",
      examples: [
        "SunTV often goes into FnO ban list and this reflect on price movement",
        "Adani Power repeatedly hit ban list during 2023-24 volatility.",
        "Zee Entertainment faced ban list pressure during merger saga.",
      ],
      caveat:
        "Ban list is a double-edged sword - some stocks rebound strongly once they exit the ban.",
    },
    {
      event: "Moat or Monopoly Break",
      rationale:
        "When a strong new player enters a market, companies with long-standing monopolies or strong moats can face intense competition, leading to pressure on pricing, margins, and market share.",
      examples: [
        "After Birla Opus entered the paint segment, Asian Paints faced selling pressure due to increased competition.",
        "When the government allowed other companies to participate in electricity futures trading, IEX stock declined.",
        "Entry of Jio significantly disrupted the telecom sector, impacting incumbent players like Idea, but Airtel able to compete",
      ],
      caveat:
        "In many cases, dominant players adapt by leveraging scale, distribution, and brand strength to defend or even strengthen their competitive position over time."
    },
    {
      event: "Earnings Miss & Guidance Cut",
      rationale:
        "When a company reports weaker-than-expected quarterly results or lowers future guidance, it signals deteriorating fundamentals, eroding investor confidence and triggering sharp sell-offs.",
      examples: [
        "Tata Motors crashed ~15% after weak JLR performance and lowered FY25 guidance.",
        "Infosys fell ~10% post Q1 2023 earnings miss and cautious FY24 revenue guidance.",
        "HUL corrected sharply after Q3 2023 volume decline and muted outlook.",
        "Bajaj Finance dropped ~12% after Q2 2024 earnings miss due to higher credit costs.",
        "Asian Paints fell ~15% after weak Q4 2024 results and cut in volume growth guidance.",
        "IndusInd Bank corrected after Q3 2025 earnings miss and cautious commentary on asset quality.",
        "Nykaa dropped ~20% after Q1 2025 results missed expectations and guidance cut."
      ],
      caveat:
        "Some misses are one-offs (e.g., temporary costs, forex impact); strong businesses can recover quickly if the miss is explained as non-recurring."
    },
    {
      event: "Rating Downgrade",
      rationale:
        "A downgrade by credit rating agencies (CRISIL, ICRA, CARE, Moody's, etc.) signals higher default risk or weaker financial health, leading to higher borrowing costs and forced selling by institutions.",
      examples: [
        "Vodafone Idea crashed repeatedly after multiple rating downgrades to junk status.",
        "Yes Bank fell sharply after rating downgrades during the 2020 crisis.",
        "Adani Group stocks corrected after Moody's and Fitch downgraded several entities post-Hindenburg.",
        "Reliance ADA Group (Anil Ambani) companies collapsed after repeated downgrades.",
        "PC Jewellers remained beaten down after multiple downgrades due to debt concerns.",
        "SBI Cards corrected after ICRA downgraded outlook on rising credit costs.",
        "Indiabulls Housing Finance fell heavily after rating downgrades in 2019-2020."
      ],
      caveat:
        "Rating agencies can sometimes be late to the party; strong recovery in fundamentals can lead to upgrades and sharp rebounds. Also, some downgrades are sector-wide and not company-specific."
    },
    {
      event: "Regulatory Fines or Penalties",
      rationale:
        "Heavy fines from regulators (SEBI, RBI, CCI, ED, etc.) signal compliance issues and can drain cash or damage reputation.",
      examples: [
        "Paytm Payments Bank crashed after RBI restrictions and heavy penalties.",
        "Adani Group stocks corrected after SEBI and other regulatory scrutiny.",
        "Future Retail collapsed under CCI and ED investigations.",
        "Manappuram Finance fell sharply after RBI penalty for gold loan violations.",
        "PC Jewellers remained beaten down after ED raids and penalties.",
        "Angel One corrected after SEBI fines for compliance issues."
      ],
      caveat:
        "Fines are sometimes one-time and manageable for large companies; resolution can lead to relief rallies."
    },
    {
      event: "Management Exit or Succession Concerns",
      rationale:
        "Sudden departure of key promoters, founders, or top executives can create uncertainty and erode investor confidence.",
      examples: [
        "Zomato fell after Deepinder Goyal's temporary exit rumours.",
        "Nykaa corrected after Falguni Nayar stepped back from day-to-day operations.",
        "Paytm crashed amid Vijay Shekhar Sharma's reduced involvement.",
        "Lenskart parent stock dropped on founder exit concerns.",
        "Byju's (pre-crisis) fell sharply after key management exits."
      ],
      caveat:
        "Strong bench strength or new leadership can stabilize the stock; some exits are planned and positive."
    }
  ];

  return (
    <section className="w-full">
      <h2 className="text-xl md:text-2xl font-semibold mb-3">Events That Can Dump Stock Prices</h2>

      {/* Mobile: Cards */}
      <div className="grid grid-cols-1 gap-3 md:hidden">
        {rows.map((r, i) => (
          <div key={i} className="rounded-xl border border-gray-200 p-4 bg-white">
            <div className="text-base font-semibold">{r.event}</div>
            <p className="mt-1 text-sm text-gray-700">
              <span className="font-medium">Why:</span> {r.rationale}
            </p>
            <div className="mt-2">
              <div className="text-sm font-medium text-gray-600">Examples</div>
              <ul className="mt-1 list-disc pl-5 text-sm text-gray-700 space-y-0.5">
                {r.examples.map((e, idx) => (
                  <li key={idx}>{e}</li>
                ))}
              </ul>
            </div>
            <p className="mt-2 text-sm text-amber-700">
              <span className="font-medium">Caveat:</span> {r.caveat}
            </p>
          </div>
        ))}
      </div>

      {/* Desktop: Table */}
      <div className="hidden md:block overflow-x-auto rounded-xl border border-gray-200 bg-white">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-50 text-gray-700">
            <tr>
              <Th>Event</Th>
              <Th>Why it can move prices</Th>
              <Th>Examples</Th>
              <Th>Caveats / Risks</Th>
            </tr>
          </thead>
        <tbody className="divide-y divide-gray-100">
            {rows.map((r, i) => (
              <tr key={i} className={i % 2 === 0 ? "bg-white" : "bg-gray-50/60"}>
                <Td className="font-semibold">{r.event}</Td>
                <Td>{r.rationale}</Td>
                <Td>
                  <ul className="list-disc pl-5 space-y-0.5">
                    {r.examples.map((e, idx) => <li key={idx}>{e}</li>)}
                  </ul>
                </Td>
                <Td className="text-amber-700">{r.caveat}</Td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

/* ============ Company Model ============ */
const CompanyModelsTable = () => {
  const rows = [
    {
      type: "Product Companies (FMCG, Auto, Pharma, Steel, Chemicals)",
      input: "Raw materials (domestic & imported), Utilities, energy",
      expenses:
        "Manufacturing (plant, machinery, depreciation), Logistics & distribution, Advertising & sales promotion",
      tax: "GST on domestic sales, Customs duty on imported inputs, Export duties/incentives on output",
      revenue:
        "Domestic sales (B2B/B2C), Export sales (forex risk, duties), Government export incentives",
    },
    {
      type: "Service Companies (IT/ITES, Consulting, Finance, Hospitality)",
      input: "Skilled human resources, Tech infra (servers, cloud, software tools)",
      expenses:
        "Salaries, hiring & retention, Offices/delivery centers, Tech infra, Sales & marketing / customer acquisition",
      tax: "GST on services, Corporate tax on profits, Limited import/export duties (e.g. infra, licenses)",
      revenue:
        "Contracts (time & material, fixed price), Subscriptions (SaaS/fintech), Advisory & consulting exports (foreign clients, forex inflows)",
    },
    {
      type: "Holding / Investment Companies",
      input: "Minimal operating inputs",
      expenses: "Administrative costs, Compliance, Audit & Legal",
      tax: "Dividend distribution tax (if applicable), Capital gains tax on share sales",
      revenue:
        "Dividends from subsidiaries, Capital gains from investments, Rental/interest income",
    },
  ];

  return (
    <div className="w-full mt-6">
      <h2 className="text-xl md:text-2xl font-semibold mb-4">
        How Companies Operate ?
      </h2>
      <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-sm">
        <table className="min-w-full text-sm md:text-base">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="p-3 text-left font-semibold border">Type of Companies</th>
              <th className="p-3 text-left font-semibold border">Input Cost</th>
              <th className="p-3 text-left font-semibold border">Major Expenses</th>
              <th className="p-3 text-left font-semibold border">Tax & Duty</th>
              <th className="p-3 text-left font-semibold border">Revenue Streams</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <tr
                key={idx}
                className={idx % 2 === 0 ? "bg-white" : "bg-gray-50"}
              >
                <td className="p-3 border align-top font-medium">{row.type}</td>
                <td className="p-3 border align-top">{row.input}</td>
                <td className="p-3 border align-top">{row.expenses}</td>
                <td className="p-3 border align-top">{row.tax}</td>
                <td className="p-3 border align-top">{row.revenue}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

/* ============ CapitalRaisingTable ============ */
const CapitalRaisingTable = ({ className = "" }) => {
  const methods = [
    { method: "Rights Issue", whoCanBuy: "Existing shareholders (in a set ratio)", moneyGoesTo: "Company", typicalUse: "Raise capital from current owners at a discount", dilution: true,  notes: "Share count increases if rights are subscribed; non-participation dilutes holding %." },
    { method: "Preferential Issue", whoCanBuy: "Selected investors (promoters, PE, FPIs, etc.)", moneyGoesTo: "Company", typicalUse: "Quick fundraising from a specific group", dilution: true, notes: "New shares are issued to a select group; existing % holding gets diluted." },
    { method: "QIP", whoCanBuy: "Qualified Institutional Buyers (QIBs)", moneyGoesTo: "Company", typicalUse: "Large, faster raise from institutions", dilution: true, notes: "Fresh equity issued to QIBs causes dilution." },
    { method: "FPO (Follow-on Public Offer)", whoCanBuy: "Public (already-listed company)", moneyGoesTo: "Company", typicalUse: "Substantial capital raising post listing", dilution: true, notes: "Fresh issue expands share base; EPS may drop initially." },
    { method: "OFS (Offer for Sale)", whoCanBuy: "Public via exchanges (with retail quota)", moneyGoesTo: "Selling shareholder", typicalUse: "Stake sale without new shares", dilution: false, notes: "No new shares created; ownership changes hands." },
    { method: "ESOP/ESPS Allotment", whoCanBuy: "Employees", moneyGoesTo: "Company", typicalUse: "Talent retention & alignment", dilution: true, notes: "Exercise/issue increases outstanding shares." },
    { method: "Buyback", whoCanBuy: "Company buys from shareholders", moneyGoesTo: "Shareholders", typicalUse: "Return excess cash, improve ratios", dilution: false, notes: "Anti-dilutive: share count decreases; EPS may improve." },
  ];

  const Pill = ({ yes }) => (
    <span
      className={clsx(
        "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ring-1",
        yes ? "bg-red-50 text-red-700 ring-red-200" : "bg-green-50 text-green-700 ring-green-200"
      )}
      title={yes ? "Dilutive" : "Not dilutive"}
    >
      {yes ? "Dilutive" : "Not dilutive"}
    </span>
  );

  return (
    <>
    <h2 className="text-2xl md:text-3xl font-semibold tracking-tight">Capital-Raising Methods After IPO</h2>
    <section className={clsx("w-full p-4 md:p-6 rounded-2xl border border-gray-200 shadow-sm", className)}>
      <p className="mt-2 text-sm md:text-base text-gray-600">
        Quick reference comparing Rights Issue, Preferential Issue, QIP, FPO, OFS, ESOP/ESPS, and Buyback — and whether they
        <span className="font-semibold"> dilute shareholding</span>.
      </p>

      {/* Card view (mobile) */}
      <div className="mt-6 grid grid-cols-1 gap-4 md:hidden">
        {methods.map((m) => (
          <div key={m.method} className="rounded-xl border border-gray-200 p-4">
            <div className="flex items-start justify-between gap-2">
              <h3 className="text-lg font-semibold">{m.method}</h3>
              <Pill yes={m.dilution} />
            </div>
            <div className="mt-3 space-y-2 text-sm">
              <Item label="Who can buy" value={m.whoCanBuy} />
              <Item label="Money goes to" value={m.moneyGoesTo} />
              <Item label="Typical use case" value={m.typicalUse} />
              <Item label="Notes" value={m.notes} />
            </div>
          </div>
        ))}
      </div>

      {/* Table view (tablet/desktop) */}
      <div className="mt-6 hidden md:block overflow-x-auto rounded-xl border border-gray-200">
        <table className="min-w-full whitespace-pre-wrap text-left text-sm md:text-base">
          <thead className="bg-gray-50">
            <tr>
              <Th>Method</Th>
              <Th>Who can buy</Th>
              <Th>Money goes to</Th>
              <Th>Typical use case</Th>
              <Th>Dilution</Th>
              <Th>Notes</Th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {methods.map((m) => (
              <tr key={m.method} className="hover:bg-gray-50/80">
                <Td className="font-semibold">{m.method}</Td>
                <Td>{m.whoCanBuy}</Td>
                <Td>{m.moneyGoesTo}</Td>
                <Td>{m.typicalUse}</Td>
                <Td><Pill yes={m.dilution} /></Td>
                <Td className="text-gray-700">{m.notes}</Td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <section className="mt-8">
        <h4 className="text-xl font-semibold">When does shareholding get diluted?</h4>
        <ul className="mt-3 list-disc pl-5 text-sm md:text-base text-gray-700 space-y-1">
          <li><span className="font-medium">Dilutive</span>: new shares are issued (Rights, Preferential, QIP, FPO, ESOP/ESPS).</li>
          <li><span className="font-medium">Not dilutive</span>: no new shares (OFS).</li>
          <li><span className="font-medium">Anti-dilutive</span>: Buyback reduces share count.</li>
        </ul>
      </section>
    </section>
    </>
  );
};

/* ============ AdvertisingMediums ============ */
const AdvertisingMediums = ({ className = "" }) => {
  const mediums = [
    { title: "Television (DTH & Cable)", examples: "Star Plus, Sony, Colors, Zee TV" },
    { title: "FM & Radio", examples: "Red FM, Big FM" },
    { title: "Digital & Social Media", examples: "Meta (Facebook, Instagram), Google (YouTube, Search, Display), X (Twitter), LinkedIn, ShareChat, Moj, DailyHunt" },
    { title: "Newspapers", examples: "Times of India, Hindustan Times, The Hindu, Dainik Jagran, Eenadu, Gujarat Samachar" },
    { title: "Outdoor (OOH & Transit)", examples: "Billboards, metro/train ads, bus wraps, airport ads, digital hoardings" },
    { title: "Cinema Advertising", examples: "Ads before movies in multiplexes (PVR, INOX, Cinepolis) and single screens" },
    { title: "OTT / Streaming", examples: "Disney+ Hotstar, JioCinema, SonyLIV, Zee5 – growing rapidly with cricket & IPL ads" },
    { title: "Influencer Marketing", examples: "YouTube, Instagram Reels, Telegram groups – strong in fashion, food, fintech" },
    { title: "E-commerce Ads", examples: "Amazon, Flipkart, Meesho – product search ads with high conversion intent" },
    { title: "In-App Ads", examples: "Gaming (Ludo King, Dream11), fintech, and regional content apps" },
  ];

  return (
    <>
    <h2 className="text-2xl font-bold text-gray-900 mb-4">Advertising Mediums in India</h2>
    <section className={clsx("w-full p-4 md:p-6 rounded-2xl border border-gray-200 shadow-sm", className)}>

      <div className="space-y-3">
        {mediums.map((item, idx) => (
          <p key={idx} className="text-sm md:text-base">
            <span className="font-semibold text-gray-900">{item.title}</span>
            <span className="text-gray-400 px-1">•</span>
            <span className="text-gray-700">{item.examples}</span>
          </p>
        ))}
      </div>
    </section>
    </>
  );
};

/* ============ Alternate data stream ============ */
const AlternateDataTable = () => {
  const rows = [
    {
      stream: "Payments & Transaction Data",
      insight:
        "UPI, credit card, POS payments reveal consumer behavior trends and demand shifts.",
      examples: [
        "Useful for FMCG, e-commerce, retail products.",
        "Rising UPI/CC spend suggests strong consumer demand."
      ],
      caveat: "Data may be aggregated or lagged; access can be restricted."
    },
    {
      stream: "New Job Openings",
      insight:
        "Sudden hiring surges can indicate new projects or business expansion.",
      examples: [
        "Aeva Technologies stock jumped 10x after a surge in LinkedIn job postings.",
        "Moschip pumped after sudden job opening spikes.",
        "IT companies' post-COVID hiring preceded stock rallies."
      ],
      caveat: "Not all roles are growth-related (could be attrition backfill)."
    },
    {
      stream: "Advertising Data",
      insight:
        "Higher ad spending signals aggressive customer acquisition or product push.",
      examples: [
        "Jeena Sheekho stock 10x after heavy ad campaigns across platforms."
      ],
      caveat: "Overspending without conversion may hurt margins."
    },
    {
      stream: "Footfall Tracking",
      insight:
        "Store visits at restaurants, retail chains, hotels, parks indicate real demand.",
      examples: [
        "Domino's crowded outlets coincided with stock rallies.",
        "D-Mart stores packed on weekends aligned with strong stock performance."
      ],
      caveat: "Foot traffic ≠ sales value; seasonal spikes may mislead."
    },
    {
      stream: "Online Visits, App Downloads & Reviews",
      insight:
        "Tracking app installs, traffic, and reviews can forecast user growth trends.",
      examples: [
        "Zomato, Swiggy, Ixigo, IndiaMart show visible traction via app store data."
      ],
      caveat: "Download spikes may include promos/freebies; sentiment analysis tricky."
    },
    {
      stream: "Social & Web Noise",
      insight:
        "Public sentiment and chatter can provide early alternate views.",
      examples: [
        "Social media buzz often precedes mainstream media coverage."
      ],
      caveat: "Noise vs signal; requires careful filtering."
    },
    {
      stream: "Satellite, Aircraft & Shipping Traffic",
      insight:
        "Satellite images, port/aircraft traffic reveal commodity flows and demand.",
      examples: [
        "Oil tanker routes help anticipate crude imports/exports.",
        "Shipping data predicts trade flows."
      ],
      caveat: "Data access expensive; interpretation needs domain expertise."
    },
    {
      stream: "Import & Export Data",
      insight:
        "Customs/port data reveal supply chain activity and demand for products.",
      examples: [
        "Export surge in chemicals or IT hardware often aligns with rallies."
      ],
      caveat: "Lagged reporting; requires aggregation."
    },
    {
      stream: "R&D, IP & Events",
      insight:
        "Patent filings, trademarks, and participation in expos reveal innovation and pipeline.",
      examples: [
        "Biotech/pharma patent filings are strong leading indicators."
      ],
      caveat: "Not every filing creates commercial success."
    }
  ];

  return (
    <section className="w-full">
      <h2 className="text-xl md:text-2xl font-semibold mb-3">
        Alternate Data Streams for Stock Insights
      </h2>

      {/* Mobile cards */}
      <div className="grid grid-cols-1 gap-3 md:hidden">
        {rows.map((r, i) => (
          <div key={i} className="rounded-xl border border-gray-200 p-4 bg-white">
            <div className="text-base font-semibold">{r.stream}</div>
            <p className="mt-1 text-sm text-gray-700">
              <span className="font-medium">Insight:</span> {r.insight}
            </p>
            <div className="mt-2">
              <div className="text-sm font-medium text-gray-600">Examples</div>
              <ul className="mt-1 list-disc pl-5 text-sm text-gray-700 space-y-0.5">
                {r.examples.map((e, idx) => (
                  <li key={idx}>{e}</li>
                ))}
              </ul>
            </div>
            <p className="mt-2 text-sm text-amber-700">
              <span className="font-medium">Caveat:</span> {r.caveat}
            </p>
          </div>
        ))}
      </div>

      {/* Desktop table */}
      <div className="hidden md:block overflow-x-auto rounded-xl border border-gray-200 bg-white">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-50 text-gray-700">
            <tr>
              <Th>Data Stream</Th>
              <Th>Insight</Th>
              <Th>Examples</Th>
              <Th>Caveats</Th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {rows.map((r, i) => (
              <tr key={i} className={i % 2 === 0 ? "bg-white" : "bg-gray-50/60"}>
                <Td className="font-semibold">{r.stream}</Td>
                <Td>{r.insight}</Td>
                <Td>
                  <ul className="list-disc pl-5 space-y-0.5">
                    {r.examples.map((e, idx) => (
                      <li key={idx}>{e}</li>
                    ))}
                  </ul>
                </Td>
                <Td className="text-amber-700">{r.caveat}</Td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};


/* ============ Page Layout ============ */
function Learning() {
  return (
    <div className="mx-auto max-w-6xl p-4 md:p-6 space-y-6">
      <CompanyModelsTable />
      <PumpEventsTable />
      <DumpEventsTable />
      <AlternateDataTable />
      <CapitalRaisingTable />
      <AdvertisingMediums />
    </div>
  );
}

export default Learning;
